export default __webpack_public_path__ + "static/media/lifesatisfaction4Img4.a82fee7e.png";